import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { Location } from '@angular/common';
import { ToasterService, Toast, BodyOutputType } from 'angular2-toaster';
import { ErrorService } from './error.service';
import * as Raven  from "raven-js"

export class RavenErrorHandler implements ErrorHandler {
  handleError(err: any): void {
    Raven.captureException(err);
  }
}

// Note that reject promises will set this error handler off
@Injectable()
export class GlobalErrorHandler extends RavenErrorHandler {
  constructor() {
    super();
  }

  handleError(error) {
    console.error(error);
    super.handleError(error);
  }
}
